import { render, staticRenderFns } from "./zoom-resetter.vue?vue&type=template&id=9f73e930&"
import script from "./zoom-resetter.vue?vue&type=script&lang=js&"
export * from "./zoom-resetter.vue?vue&type=script&lang=js&"
import style0 from "./_zoom-resetter.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports